export default "__VITE_ASSET__8ZJMA4Zf__"